/* eslint-disable quotes */
'use strict';

/**
 * config.ts
 * @createdOn:24-Nov-2017
 * @author:SmartChartsNXT
 * @description:This will be the Global default configuration for all charts.
 */

export default {
  theme: {
    fontFamily: "Lato, sans-serif",
    fontColorLight: "#fff",
    fontColorMedium: "#848484",
    fontColorDark: "#000",
    fontColorHighlight: "#09b0de",
    fontSizeSmall: 9,
    fontSizeMedium: 14,
    fontSizeLarge: 18,
    bgColorLight: "#fff",
    bgColorMedium: "#8B8A88",
    bgColorDark: "#000"
  },
  formatting: {
    parseDateFormat: '',
    displayDateFormat: "DD MMM, YY"
  }
};